import React, { memo, PropsWithChildren } from "react";
import { Typography } from "antd";
// import cx from "classnames";
// import styles from "./Text.module.scss";
// import { TextProps } from "antd/lib/typography/Text";
import { TitleProps } from "antd/lib/typography/Title";

interface IProps extends TitleProps {}

const Title = ({ children, ...rest }: PropsWithChildren<IProps>) => {
  // const classNames = cx({
  //   [styles.small]: size === ModalSize.SMALL,
  //   [styles.medium]: size === ModalSize.MEDIUM,
  //   [styles.large]: size === ModalSize.LARGE,
  // });
  const { Title: AntDTitle } = Typography;
  return (
    <div>
      <AntDTitle {...rest}>{children}</AntDTitle>
    </div>
  );
};

export default memo(Title);
